export default __webpack_public_path__ + "static/char-57-286fc0d2180910b69ec267a556bf9ca6.gif";